import { createSlice } from '@reduxjs/toolkit';

export const vehicleSlice = createSlice({
    name: 'vehicle',
    initialState: {
        dataToAction: { name: '', key: '', created: '', modality: '', holding: '', address: '', zipCode: ''}
    },
    reducers: {
        selectVehicle: (state, {payload}) => {
            state.dataToAction = payload;
        },
        unSelectVehicle: (state) => {
            state.dataToAction = {
                userToAction: { name: '', key: '', created: '', modality: '', holding: '', address: '', zipCode: ''}
            }
        }
    }
});

export const { selectVehicle, unSelectVehicle } = vehicleSlice.actions;